<!-- eslint-disable -->
<template lang="pug">
    .row.dashboard-box(v-if="isLoaded && user")
        .col-xs-12.col-lg-7.col-xl-8.dashboard-box__column
            user
            block-notification(
                v-if="!user.isSuperadmin && user.type !== 'admin' && (hasBlockedSchools || hasBlockedAccount)"
                :user-is-admin="user.type === 'admin'"
                :schools-blocked="hasBlockedSchools"
                :users-account-blocked="hasBlockedAccount"
            )
            education(v-if="user.type === 'student' || user.type === 'teacher'")
            homeworks(v-if="user.type === 'student'")
            billing(v-if="isBillingAvailable")
                block-notification(
                    v-if="!user.isSuperadmin&& (hasBlockedSchools || hasBlockedAccount)"
                    :user-is-admin="user.type === 'admin'"
                    :schools-blocked="hasBlockedSchools"
                    :users-account-blocked="hasBlockedAccount"
                )

                pay-notification(v-if="!user.isSuperadmin && isAnySchoolWithoutTransactions")
                template(
                    v-if="!user.isSuperadmin && accountsToBeBlocked && showPayNotificationNextReportPeriod"
                    v-for="(sum) in accountsToBeBlocked"
                )
                    pay-notification(
                        v-if="sum"
                        :need-to-pay="sum"
                        :user="user"
                    )
            create-banner(v-if="user.type === 'admin' || user.isManagerOrSupport")
        .col-xs-12.col-lg-5.col-xl-4.dashboard-box__column
            map-banner(v-if="isMapAvailable")
            detective-banner(v-if="isDetectiveAvailable")
            battle-rating(v-if="isBattleRatingAvailable")
            rating(v-if="user.type === 'student' && $pointsSystem && user.type !== 'olympiads-student' && user.pointsAccesses.length")
            timetable(v-if="!user.isSuperadmin && user.type === 'admin'")
            todo-list(v-if="user.type !== 'student' && user.type !== 'olympiad-student'")
            messages(v-if="!canShowConversations")
            confirmations(v-if="$scoring && $pointsSystem && user.type === 'admin'")
    cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex'
    import canShowConversations from '../../utils/user/canShowConversations'
    import courseAccesses from '../../utils/user/courseAccesses'
    import BillingBlockMixin from '../../utils/user/BillingBlockMixin'

    //right blocks
    import User from './dasboard-elements/User.vue'
    import Education from './dasboard-elements/Education.vue'
    import Homeworks from './dasboard-elements/Homeworks.vue'
    import CreateBanner from './dasboard-elements/CreateBanner.vue'
    import Billing from './dasboard-elements/Billing.vue'
    import BlockNotification from './dasboard-elements/BlockNotification.vue'
    import PayNotification from './dasboard-elements/PayNotification.vue'

    //left blocks
    import NewsBanner from "@/components/dashboard/dasboard-elements/NewsBanner.vue";
    import BattlesBanner from "@/components/dashboard/dasboard-elements/BattlesBanner.vue";
    import OlympiadBanners from './dasboard-elements/Olympiad.vue'
    import MapBanner from './dasboard-elements/Map.vue'
    import DetectiveBanner from './dasboard-elements/Detective.vue'
    import TodoList from './dasboard-elements/TodoList.vue'
    import Messages from './dasboard-elements/Messages.vue'
    import Rating from './dasboard-elements/Rating.vue'
    import BattleRating from './dasboard-elements/BattleRating.vue'
    import Timetable from './dasboard-elements/Timetable.vue'
    import Confirmations from './OldElements/Confirmations.vue'

    import UserApi from '../../api/user/user'

    const BANNERS_ACCESSES = {
        olympiad: {
          general: ["student", "olympiads-student", "admin", "teacher"],
          service: ['admin', 'teacher']
        }
    };

    export default {
        components: {
            //right blocks
            User,
            Education,
            Homeworks,
            CreateBanner,
            Billing,
            BlockNotification,
            PayNotification,
            NewsBanner,
            //left blocks
            OlympiadBanners,
            MapBanner,
            DetectiveBanner,
            TodoList,
            Messages,
            Rating,
            BattleRating,
            Timetable,
            Confirmations,
            BattlesBanner,
        },
        mixins: [canShowConversations, courseAccesses, BillingBlockMixin],
        created () {
            this.updateUser()
        },
        mounted () {
            this.getUserAccountsInfo();
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
            isMapAvailable () {
                return this.user.type === 'student' && this.user.type !== 'olympiads-student'
                        && this.$isMapAvailable && this.courseAllowMap
                        && this.selectedCourse === 'mentalArithmetic'
            },
            isBattleBannerAvailable () {
                return this.selectedCourse === 'mentalArithmetic' || this.user.pointsAccesses.includes('mentalArithmetic');
            },
            isFastReadingAvailable () {
                return this.selectedCourse === 'fastReading' || this.user.pointsAccesses.includes('fastReading');
            },
            isPractiseBannerAvailable () {
                return this.user.type === 'teacher' || this.user.type === 'admin' || this.user.isManagerOrSupport || this.user.isSuperadmin;
            },
            isNewsBannerAvailable () {
                return this.user.type !== 'student'
            },
            isDetectiveAvailable () {
                return this.user.type === 'student' && this.user.type !== 'olympiads-student'
                        && this.$isDetectiveAvailable && this.courseAllowDetective
                        && this.selectedCourse === 'fastReading'
            },
            isBillingAvailable () {
                return this.user.schools.some(school => school.mainContactId === this.user.id && school.isBillingActive)
            },
            isBattleRatingAvailable () {
                return this.user.type === 'student'
                    && this.user.pointsAccesses.length
                    && ['mentalArithmetic', 'russianLanguage'].includes(this.selectedCourse);
            },
            hasBlockedSchools () {
                if (this.user && this.user.schools) {
                    return this.user.schools.some(school => school.isBillingActive ? !school.account.status : false);
                }
                return false;
            },
            hasBlockedAccount () {
                if (this.user && this.user.schools && this.user.schools.some(school => school.studentPayed && school.isBillingActive)) {
                    return this.user.account && !this.user.account.status;
                }
                return false;
            },
            isOlympiadBannerAvailable () {
                return BANNERS_ACCESSES.olympiad.general.includes(this.user.type);
            },
            isActiveAdminOrTeacher () {
              return BANNERS_ACCESSES.olympiad.service.includes(this.user.type);
            },
        },
        methods: {
            updateUser () {
                this.$store.dispatch('setUserByToken')
                .then(() => {
                    this.isLoaded = true
                })
                .catch(err => {
                    this.$toasted.error(this.$i18n.t('errors.getting_user'))
                })
            },
            getUserAccountsInfo() {
              UserApi.getUserAccountsInfo()
                .then(data => {
                  if (this.user.type === 'admin' && Object.keys(data.schoolsAccountsToBeBlocked).length) {
                      this.accountsToBeBlocked = data.schoolsAccountsToBeBlocked;
                      this.isAnySchoolWithoutTransactions = data.isAnySchoolWithoutTransactions;
                      this.showPayNotificationNextReportPeriod = data.showPayNotificationNextReportPeriod;
                  }
                }).catch(err => {
                if (err.status && err.status === 503) {
                  this.$toasted.error(err.message);
                }
              })
            }
        },
        data () {
            return {
                isLoaded: false,
                accountsToBeBlocked: null,
                isAnySchoolWithoutTransactions: false,
                showPayNotificationNextReportPeriod: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-box {
        margin: 0;
        padding: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        @include media($sm) {
            padding: 15px;
            border-radius: 40px;
        }
    }

    .dashboard-box__column {
        padding: 15px 0;
        @include media($sm) {
            padding: 15px;
        }
    }

    .subscription-banner, .school-preparation-banner {
        margin-bottom: 30px;
    }
</style>
